// Waypoint for promo module (size-jumbo)
if (document.querySelector(".m-promo.size-jumbo")) {
  const mobileOffset = "75%";
  const desktopOffset = "66.66%";

  function handleHeading(element, offset) {
    new Waypoint({
      element: element,
      handler: function () {
        element.classList.add("active");
      },
      offset: offset,
    });
  }

  document
    .querySelectorAll(".m-promo.size-jumbo .heading--mobile")
    .forEach((element) => handleHeading(element, mobileOffset));

  document
    .querySelectorAll(".m-promo.size-jumbo .heading--desktop")
    .forEach((element) => handleHeading(element, desktopOffset));
}
